var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTask(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 41,
    viewBox: "0 0 33 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.7037 32.25L26.0037 20.95L23.1037 18.05L14.6537 26.5L10.4537 22.3L7.60371 25.15L14.7037 32.25ZM4.80371 40.25C3.70371 40.25 2.76171 39.858 1.97771 39.074C1.19371 38.29 0.802381 37.3487 0.803714 36.25V4.25C0.803714 3.15 1.19571 2.208 1.97971 1.424C2.76371 0.640003 3.70505 0.24867 4.80371 0.250003H20.8037L32.8037 12.25V36.25C32.8037 37.35 32.4117 38.292 31.6277 39.076C30.8437 39.86 29.9024 40.2513 28.8037 40.25H4.80371ZM18.8037 14.25H28.8037L18.8037 4.25V14.25Z",
    fill: "#00AB55"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTask);
export default __webpack_public_path__ + "static/media/Task.981df044c946889098625ae827620543.svg";
export { ForwardRef as ReactComponent };